export default __webpack_public_path__ + "static/media/co-online@3x.4fd4e6e0.png";